import styled, { css } from 'styled-components'

import { ReactComponent as QuestionMark } from '@sketch/icons/circle-question-mark-button-translucent-17'

type StyledHelpIconProps = {
  $isLink: boolean
}
export const StyledHelpIcon = styled(QuestionMark)<StyledHelpIconProps>`
  width: 17px;
  height: 17px;
  margin-left: 4px;
  vertical-align: sub;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};

  ${({ $isLink }) =>
    $isLink &&
    css`
      &:hover {
        color: ${({ theme }) => theme.colors.foreground.secondary.A};
      }
    `}
`
